import React, {Component} from "react"
import {withTranslate} from "react-redux-multilingual";
import Plans from "../../components/Plans";
//import Head from "../components/Head";
import globalMiddleware from "../../hocs/globalMiddleware";
import Login from "../auth/Login";
import Register from "../auth/Register";
import {changeAuthPopUpStatus} from "../../store/actions/reservationActions";
import {authTogglePopUpStatus, profile} from "../../store/actions/userActions";
import {connect} from "react-redux";
import {
    FacebookIcon,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton
} from "react-share";
import {setShareIconsSkeleton} from "../../skeleton";
import {clearError500, setCurrentRoute} from "../../store/actions/globalActions";
import {getPlans} from "../../store/actions/planActions";
import Maintenance from "../../components/Maintenance";

class PremiumBenefits extends Component {
    constructor(props) {
        super(props);
        this.token = localStorage.getItem("access_token") ? JSON.parse(localStorage.getItem("access_token")) : null;
    }

    componentDidMount() {
        this.props.clearError500();

        this.props.getPlans();

        this.props.setCurrentRoute(window.location.href);

        if (this.token !== null) {
            this.props.profile();
        }
        // to reset popup
        this.props.authTogglePopUpStatus(false);
        this.props.changeAuthPopUpStatus(false);

        let popUp = document.getElementById("auth-pop-up");
        window.onclick = (e) => {
            console.log(e,";;l;")

            if (e.target === popUp) {
                this.props.changeAuthPopUpStatus(false);
                popUp.style.width = "0";
            }
        };
        window.scrollTo(0, 0);
    }

    becomePremiumBySharing = (e) => {
        if (this.token === null) {
            // localStorage.setItem("reservation", JSON.stringify(cachedData));
            this.changeAuthFormStatus(e, "open");
            this.props.changeAuthPopUpStatus(true);
        }
    };
    changeAuthFormStatus = (e, status) => {
        e.preventDefault();

        if (status === "close") {
            this.props.changeAuthPopUpStatus(false);

            document.getElementById("auth-pop-up").style.width = "0";
        } else {
            this.props.changeAuthPopUpStatus(true);

            document.getElementById("auth-pop-up").style.width = window.innerWidth + "px";
            document.getElementById("auth-pop-up").style.height = window.innerHeight + "px";
        }
    };

    render() {

        if (this.props.error500) {
            return (
                <Maintenance/>
            )
        }
        return (
            <div>
                <div className="container" id="premium">
                    <div className="row ">
                        <div className="col-xs-12 col-sm-12 ">
                            <div id="productfeatured">
                                <div className="boxApollo">

                                    <div className="apolloHeading">
                                        <h3 className="page-subheading heading-style1">
                                            <span className="subheading-text">{this.props.translate("benefits")}</span>
                                            <span
                                                className="description" style={this.props.language === "ar" ?  {letterSpacing: "1px"} : {letterSpacing: "6px"}}>{this.props.translate("enjoy_unlimited_discount")}</span>
                                        </h3>
                                    </div>

                                    <div className="apolloDescription row clearfix">
                                        <div className="col-md-4 col-sm-12">
                                            <div className="feature-box mb-40">
                                                <div className="fbox-image">
                                                    <img
                                                        src="../images/no-medical-approval.png"
                                                        alt="All terrain suitability"/>
                                                </div>
                                                <div className="fbox-content">
                                                    <div className="fbox-body">
                                                        <h4>{this.props.translate("no_medical_approval")}</h4></div>
                                                    <p className="description">{this.props.translate("no_medical_approval_desc")}</p>
                                                </div>
                                            </div>
                                            <div className="feature-box premium-box">
                                                <div className="fbox-image">
                                                    <img
                                                        src="../images/benefit.png"
                                                        alt="All terrain suitability"/>
                                                </div>
                                                <div className="fbox-content">
                                                    <div className="fbox-body">
                                                        <h4>{this.props.translate("special_discounts")}</h4></div>
                                                    <p className="description">{this.props.translate("special_discounts_desc")}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-sm-12 premium-img-tag">
                                            <img className="img-responsive" alt="STROLLIK E2"
                                                 src="../images/premium-tag.png"
                                            />
                                        </div>
                                        <div className="col-md-4 col-sm-12">
                                            <div className="feature-box mb-40">
                                                <div className="fbox-image">
                                                    <img
                                                        src="../images/history.png"
                                                        alt="All terrain suitability"/>
                                                </div>
                                                <div className="fbox-content">
                                                    <div className="fbox-body">
                                                        <h4>{this.props.translate("personal_data")}</h4></div>
                                                    <p className="description">{this.props.translate("personal_data_desc")}</p>
                                                </div>
                                            </div>
                                            <div className="feature-box">
                                                <div className="fbox-image">
                                                    <img
                                                        src="../images/premium-points.png"
                                                        alt="All terrain suitability"/>
                                                </div>
                                                <div className="fbox-content">
                                                    <div className="fbox-body">
                                                        <h4>{this.props.translate("all_terrain_suitability")}</h4></div>
                                                    <p className="description">{this.props.translate("all_terrain_suitability_desc")}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 mb-50">
                            <Plans plans={this.props.plans}
                                   plansIsLoading={this.props.plansIsLoading}
                            // localStorage.setItem("reservation", JSON.stringify(cachedData));
                                   changeAuthFormStatus={(e, status) =>this.changeAuthFormStatus(e, status)}
                                   changeAuthPopUpStatus={(status) => this.props.changeAuthPopUpStatus(status)}
                        />
                        </div>
                        <div className="col-xs-12 col-sm-12  share_premium_area">
                            <div className="mb-50">
                                <h1 className="capitalized black text-center">
                                    {this.props.translate("become_premium_by_sharing") + "!"}
                                </h1>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <img
                                        src="../images/premium_girl.png"
                                        alt="All terrain suitability"/>
                                </div>
                                <div className="col-md-6 share_premium_text">
                                    <p>{this.props.translate("become_premium_by_sharing_text")}</p>
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-12 mt-50">
                                <div className="premium-btn">
                                    {this.token !== null || this.props.authSuccess ?
                                        !this.props.authUserIsLoading ?
                                            <div className="share-area">
                                                <FacebookShareButton
                                                    url={window.location.origin + "/user/" + this.props.authUser.unique_id}>
                                                    <FacebookIcon size={32} round/>
                                                </FacebookShareButton>
                                                <LinkedinShareButton
                                                    url={window.location.origin + "/user/" + this.props.authUser.unique_id}>
                                                    <LinkedinIcon size={32} round/>
                                                </LinkedinShareButton>
                                                <TwitterShareButton
                                                    url={window.location.origin + "/user/" + this.props.authUser.unique_id}>
                                                    <TwitterIcon size={32} round/>
                                                </TwitterShareButton>
                                                <WhatsappShareButton
                                                    url={window.location.origin + "/user/" + this.props.authUser.unique_id}>
                                                    <WhatsappIcon size={32} round/>
                                                </WhatsappShareButton>
                                            </div> :
                                            <div className="share-area-skeleton">
                                                {setShareIconsSkeleton(4)}
                                            </div>
                                        :
                                        <a className="cursor-pointer"
                                           onClick={(e) => this.becomePremiumBySharing(e)}>{this.props.translate("upgrade_now")}</a>
                                    }
                                </div>
                            </div>
                        </div>

                        <div hidden={this.props.authPopUpStatus === false}
                             className="pop-up" id="auth-pop-up">
                            <div className="flex-align-center" hidden={this.props.authToggleFormStatus}>
                                <Login
                                    changeAuthFormStatus={(e, status) => this.changeAuthFormStatus(e, status)}/>
                            </div>
                            <div className="flex-align-center" hidden={!this.props.authToggleFormStatus}>
                                <Register
                                    changeAuthFormStatus={(e, status) => this.changeAuthFormStatus(e, status)}/>
                            </div>
                        </div>

                        {/*   <div className="col-xs-12 col-sm-12 mb-50">
                            <div className="premium-btn">
                                <a href="/download">{this.props.translate("upgrade_now")}</a>
                            </div>
                        </div>*/}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        // for show/hide pop up
        authPopUpStatus: state.reservation.authPopUpStatus,
        //for show login or register
        authToggleFormStatus: state.user.authToggleFormStatus,

        authUser: state.user.authUser,
        authUserIsLoading: state.user.authUserIsLoading,
        authSuccess: state.user.authSuccess,
        plans: state.plan.plans,
        plansIsLoading: state.plan.plansIsLoading,
        error500: state.global.error500,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        // for show/hide pop up
        changeAuthPopUpStatus: (status) => dispatch(changeAuthPopUpStatus(status)),
        //for show login or register
        authTogglePopUpStatus: (status) => dispatch(authTogglePopUpStatus(status)),

        profile: () => {
            dispatch(profile())
        },
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),

        getPlans: () => dispatch(getPlans()),

        clearError500: () => dispatch(clearError500()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(PremiumBenefits)))